var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GraphRouter } from './main';
import { getFeatureCoordinate, getFeatureBoolean, getFeatureIntegerArray, getFeatureLocationId } from './utils';
const mapboxKey = 'pk.eyJ1Ijoic21hcnRsaW5rZGV2IiwiYSI6ImNqc3Z2dHU5bjA4dWE0NHBqa3U4dnE0aTIifQ.Cctjg3CDUrjXHSBL_itBRA';
export default class MapboxRouter {
    constructor(settings) {
        this.floors = [];
        this.graph = new GraphRouter();
        if (settings.routingAccuracy) {
            this.graph.tolerance = parseFloat(settings.routingAccuracy.toString());
        }
    }
    static Create(settings) {
        return __awaiter(this, void 0, void 0, function* () {
            const router = new MapboxRouter(settings);
            if (settings.floors) {
                const promises = settings.floors.map((floor) => {
                    return router.loadFloorData(floor);
                });
                yield Promise.all(promises);
            }
            return router;
        });
    }
    loadFloorData(floor) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = `https://api.mapbox.com/datasets/v1/smartlinkdev/${floor.id}/features?access_token=${mapboxKey}`;
            if (floor.dataset_id) {
                url = `https://api.roveiq.com/v1/datasets/${floor.dataset_id}`;
            }
            try {
                const responseFetch = yield fetch(url);
                const response = yield responseFetch.json();
                const featureCollection = response;
                const locations = [];
                featureCollection.features.forEach((feature) => {
                    if (feature.geometry.type === 'LineString') {
                        for (let i = 0; i < feature.geometry.coordinates.length - 1; i++) {
                            const pos1 = {
                                floorIndex: floor.index,
                                coordinate: feature.geometry.coordinates[i],
                            };
                            const pos2 = {
                                floorIndex: floor.index,
                                coordinate: feature.geometry.coordinates[i + 1],
                            };
                            this.graph.addEdge(pos1, pos2, { isStairs: false });
                        }
                    }
                    else if (feature.properties && feature.properties.floors) {
                        const floorIds = getFeatureIntegerArray(feature, 'floors');
                        if (floorIds.length === 0) {
                            console.warn('Stairs with no floor ids', feature);
                            return;
                        }
                        const door = getFeatureCoordinate(feature, 'door');
                        const output = getFeatureCoordinate(feature, 'output');
                        const direction = feature.properties.direction || '';
                        const handicapAccessible = getFeatureBoolean(feature, 'handicap');
                        const handicapOnly = getFeatureBoolean(feature, 'handicapOnly');
                        if (!door || !output) {
                            console.error('invalid floor transition', { door, output });
                            return;
                        }
                        floorIds.forEach((floorId) => {
                            this.graph.addEdge({ floorIndex: floor.index, coordinate: door }, { floorIndex: floorId, coordinate: output }, { isStairs: true, handicapOnly, handicapAccessible, direction });
                        });
                    }
                    else if (feature.geometry.type === 'Polygon') {
                        const loc_id = getFeatureLocationId(feature);
                        if (loc_id === 0) {
                            return;
                        }
                        const door = getFeatureCoordinate(feature, 'door');
                        if (door) {
                            locations.push({
                                locationId: loc_id,
                                door,
                            });
                        }
                    }
                });
                this.floors.push({ mapboxFloor: floor, featureCollection, locations });
            }
            catch (e) {
                console.error('error getting data from mapbox: ', e);
            }
        });
    }
    getLocationPosition(locationId) {
        let found;
        this.floors.forEach((floor) => {
            if (found) {
                return;
            }
            const foundLoc = floor.locations.find((location) => parseInt(location.locationId.toString()) === parseInt(locationId.toString()));
            if (foundLoc) {
                found = {
                    floorIndex: floor.mapboxFloor.index,
                    coordinate: foundLoc.door,
                };
            }
        });
        return found;
    }
    CoordinateToLocation(start, locationId, handicapMode) {
        const found = this.getLocationPosition(locationId);
        if (!found) {
            throw `Location ${locationId} not found`;
        }
        return this.graph.findRoute(start, found, handicapMode);
    }
    CoordinateToCoordinate(start, end, handicapMode) {
        return this.graph.findRoute(start, end, handicapMode);
    }
    LocationToLocation(startLocationId, endLocationId, handicapMode) {
        const startFound = this.getLocationPosition(startLocationId);
        if (!startFound) {
            throw `Location ${startLocationId} not found`;
        }
        const endFound = this.getLocationPosition(endLocationId);
        if (!endFound) {
            throw `Location ${endLocationId} not found`;
        }
        return this.graph.findRoute(startFound, endFound, handicapMode);
    }
}
